import React, { FC, useState } from 'react'
import './TaxUpdate.scss'

import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import employeeService from 'Services/employeeService'

interface propsType {
  toggleModal: () => void
}

export type taxUpdate = {
  taxNumber: string
  state: string
}

const schema = yup.object().shape({
  taxNumber: yup.string().required('Field is required'),
  state: yup.string().required('Field is required'),
})

const TaxUpdate: FC<propsType> = ({ toggleModal }) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<taxUpdate>({
    resolver: yupResolver(schema),
  })

  const { showAlert } = ShowTGAlert()
  const [request, setRequest] = useState(false)

  const submitNewUserInformation = handleSubmit(async (data: taxUpdate) => {
    // await employeeService.createNew(data).then(
    //   () => {
    //     setRequest(false)
    //     toggleModal()
    //     showAlert({
    //       message: 'Pension Details updated successfully',
    //       show: true,
    //       title: 'Success',
    //       type: 'success',
    //     })
    //     setTimeout(() => {
    //       window.location.reload()
    //     }, 200)
    //   },
    //   (error: { response: { data: { error: string } } }) => {
    //     setRequest(false)
    //     toggleModal()
    //     showAlert({
    //       message: error.response.data.error,
    //       show: true,
    //       title: 'Error',
    //       type: 'error',
    //     })
    //   },
    // )
  })
  return (
    <div className='tax-update'>
      <form action='/product-scanner'>
        <div className='form-group mb-3'>
          <label htmlFor='price-per-lit'>Tax ID</label>
          <input
            placeholder='Tax ID'
            type='text'
            id='taxNumber'
            className='form-control'
            {...register('taxNumber')}
          />
          {errors.taxNumber && <div className='text-danger'>{errors.taxNumber.message}</div>}
        </div>

        <div className='form-group mb-3'>
          <label htmlFor='state'>Residential State</label>
          <select id='state' defaultValue='' className='form-control' {...register('state')}>
            <option disabled value=''>
              --Select State--
            </option>
            <option value='lagos'>Lagos</option>
            <option value='kwara'>Kwara</option>
            <option value='ogun'>Ogun</option>
          </select>
          {errors.state && <div className='text-danger'>{errors.state.message}</div>}
        </div>
        <div className='form-group'>
          <button
            className='btn btn-default-2 w-100'
            onClick={(e) => submitNewUserInformation(e)}
            disabled={request}
          >
            Save Details {request && <span className='spinner-border spinner-border-sm'></span>}
          </button>
        </div>
      </form>
    </div>
  )
}

export default TaxUpdate
